import {HTMLAttributes} from 'react';
import styled from 'styled-components';
import Portal from '@/components/Portal';
import {FULL_SCREEN, palette, Z_INDEX} from '@/styles';

interface IProps extends HTMLAttributes<HTMLDivElement> {}

export const FullPageModal = (props: IProps) => {
  return (
    <Portal>
      <Root {...props} />
    </Portal>
  );
};

const Root = styled.div`
  position: fixed;
  background-color: ${palette.white};
  left: 0;
  top: 0;
  width: ${FULL_SCREEN.vw};
  height: ${FULL_SCREEN.vh};
  z-index: ${Z_INDEX.modal};
`;
